module.exports = __webpack_public_path__ + "static/img/bl_head_ok.471da9c6.webp";